import React, { useCallback, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-deprecated
import { verifyEmail, verifyPhone } from '~shared/actions/verifications';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { CommsVerificationStatus } from './CommsVerificationStatus';

type Props = {
  readonly params: {
    commsChannel: string;
    token: string;
  };
};

export const CommsVerificationStatusContainer = ({ params }: Props) => {
  const loading = useSelectorShared((state) => state.ui.loading.verifyCommsLoading);
  const dispatch = useDispatchShared();
  const [isVerified, setIsVerified] = useState<boolean | null | undefined>(null);
  const { commsChannel, token } = params;

  const onVerify = useCallback(async () => {
    if (commsChannel === 'phone') {
      // eslint-disable-next-line import/no-deprecated
      const response = await dispatch(verifyPhone(token));
      setIsVerified(response);
    } else if (commsChannel === 'email') {
      // eslint-disable-next-line import/no-deprecated
      const response = await dispatch(verifyEmail(token));
      setIsVerified(response);
    }
  }, [commsChannel, dispatch, token]);

  useEffect(() => {
    onVerify();
  }, [onVerify]);

  return (
    <CommsVerificationStatus
      isVerified={isVerified}
      loading={loading}
      commsChannel={commsChannel}
      token={token}
      authorized
    />
  );
};
